import React, { useState } from "react";
import {
  Icon,
  Menu,
  Accordion,
} from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import './Explorerbar.css'
import { getDatabases, setActiveDbName, setTableInfo, getSecurityKey } from "../../features/tableData/visualSlice";
import axios from "axios";


const Databar = () => {
  const [activeDbIndex, setActiveDbIndex] = useState(0);
  const [activeTable, setActiveTable] = useState("");
  const databases = useSelector(getDatabases);
  const dispatch = useDispatch();
  const securityKey = useSelector(getSecurityKey);

  const handleDbClick = (dbName, dbIndex) => {
    if(activeDbIndex === dbIndex){
        setActiveDbIndex(-1);
    }
    else{
        setActiveDbIndex(dbIndex);
        dispatch(setActiveDbName(dbName));
    }
  };

  const handleTableClick = async (dbName, tableName) => {
    console.log(dbName);
    console.log(tableName);
    setActiveTable(tableName);
    //get data from backend here
    const promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_table_info`, {params : {securityKey: securityKey, dbName: dbName, tableName: tableName}});
    promise.then((response) => {
        console.log(response.data);
        dispatch(setTableInfo(response.data));
      },
      (error) => {
        console.log(error);
      }
    );

  };


  return (
          <>
            <Menu.Item>
              Databases
            </Menu.Item>
            <Menu.Item className="no_padding_accordian">
            <Accordion fluid>
              {databases.map((database, index) => {
                return (
                    <>
                      <Accordion.Title
                        active={activeDbIndex === index}
                        onClick={() => handleDbClick(database.name, index)}
                      >
                        <Icon name="dropdown" />
                        {database.name}
                      </Accordion.Title>
                      <Accordion.Content active={activeDbIndex === index}>
                        {activeDbIndex!==-1 && <Menu vertical fluid>
                          {
                            databases[activeDbIndex].tables.map((table, _) => {
                              return (
                                  <Menu.Item
                                    name={table.name}
                                    active={activeTable === `${table.name}`}
                                    onClick={() => handleTableClick(database.name, table.name)}
                                  >
                                    {table.name}
                                  </Menu.Item>
                              );
                            })
                          }
                          </Menu>
                        }
                      </Accordion.Content>
                    </>
                );  
              })}
            </Accordion>
            </Menu.Item>
          </>
  );
};

export default Databar;